<template>
  <div id="reimbursement">
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form class="create-form">
      <div class="" style="width: 90%; margin: 0 auto;">
        <van-field
          v-model="input_content"
          rows="2"
          autosize
          type="textarea"
          placeholder="请输入待解析内容案例：gucci上海恒隆/古驰上海恒隆"
          show-word-limit
        />
        <div style="width: 100px;margin: 5px auto; padding: 2px 0; border-radius: 6px; color: #FFFFFF; border: 1px solid #1989fa; background-color: #1989fa;" @click="explain">智能解析</div>
      </div>
      <div class="create-title">
        <van-field
          v-if="reim_no"
          clickable
          readonly
          name="picker"
          :value="reim_no"
          label="报销单编号"
          placeholder="报销单编号"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="showForm.city_name"
          label="城市"
          placeholder="城市"
          :rules="[{ required: true, message: '城市' }]"
          @click="showCityPicker = true"
        />
        <van-popup v-model="showCityPicker" position="bottom">
          <van-picker
            title="请选择城市"
            show-toolbar
            :columns="cityList"
            value-key="city_cn"
            @confirm="onConfirmCity"
            @cancel="showCityPicker = false"
            :default-index="showForm.cityIndex"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="showForm.brand_name"
          label="品牌"
          placeholder="品牌"
          @click="showBrandPicker = true"
          :rules="[{ required: true, message: '品牌' }]"
        />
        <van-popup v-model="showBrandPicker" position="bottom">
          <van-picker
            title="请选择品牌"
            show-toolbar
            :columns="brandsList"
            value-key="brand_en"
            @confirm="onConfirmBrand"
            @cancel="showBrandPicker = false"
            @change="onChangeBrand"
            :default-index="showForm.brandIndex"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="showForm.market_name"
          label="商场"
          placeholder="商场"
          @click="showMarketPicker = true"
          :rules="[{ required: true, message: '商场' }]"
        />
        <van-popup v-model="showMarketPicker" position="bottom">
          <van-picker
            title="请选择商场"
            show-toolbar
            :columns="marketsList"
            value-key="market_cn"
            @confirm="onConfirmMarket"
            @cancel="showMarketPicker = false"
            :default-index="showForm.marketIndex"
          />
        </van-popup>
        <van-field
          v-model="showForm.store_cn"
          name="店铺"
          label="店铺"
          placeholder="店铺"
          readonly
          @click="showStorePicker = true"
          :rules="[{ required: true, message: '店铺名' }]"
        />
        <van-popup v-model="showStorePicker" position="bottom">
          <van-picker
            title="请选择店铺名"
            show-toolbar
            :columns="storeList"
            value-key="name_cn"
            @confirm="onConfirmStore"
            @cancel="showStorePicker = false"
            :default-index="showForm.storeIndex"
          />
        </van-popup>
        <van-field
          v-model="showForm.company_en"
          name="公司"
          label="公司"
          placeholder="公司"
          readonly
          @click="showCompanyPicker = true"
          :rules="[{ required: true, message: '公司' }]"
        />
        <van-popup v-model="showCompanyPicker" position="bottom">
          <van-picker
            title="请选择公司"
            show-toolbar
            :columns="companies"
            value-key="company_en"
            @confirm="onConfirmCompany"
            @cancel="showCompanyPicker = false"
            @change="onChangeCompany"
            :default-index="showForm.companyIndex"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="showForm.ma_type_cn"
          label="维修类型"
          placeholder="维修类型"
          @click="showTypePicker = true"
          :rules="[{ required: true, message: '维修类型' }]"
        />
        <van-popup v-model="showTypePicker" position="bottom">
          <van-picker
            title="请选择维修类型"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
            :default-index="showForm.typeIndex"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="showForm.ma_cate_cn"
          label="维修项目"
          placeholder="选择维修项目"
          @click="showPicker = true"
          :rules="[{ required: true, message: '维修项目' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            title="请选择维修项目"
            show-toolbar
            :columns="projects"
            value-key="name"
            @confirm="onConfirmColumn"
            @cancel="showPicker = false"
            @change="onChangeColumn"
            :default-index="showForm.projectIndex"
          />
        </van-popup>
        <van-field name="radio" label="是否完工" v-if="addForm.pre_quote_status != 1">
          <template #input>
            <van-radio-group v-model="addForm.is_completed" direction="horizontal">
              <van-radio :name="0">否</van-radio>
              <van-radio :name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-cell v-if="addForm.is_completed == 1" title="完工日期" :value="addForm.completed_at" style="text-align: left;" @click="showRepairStartTime = true" />
        <van-popup v-model="showRepairStartTime" position="bottom">
          <van-datetime-picker
            type="date"
            title="完工日期"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="selectStartDate"
            @cancel="cancelStartDate"
          />
        </van-popup>
        <van-field
          v-model="addForm.ma_remark"
          rows="3"
          autosize
          label="工作内容"
          type="textarea"
          placeholder="工作内容"
          :rules="[{ required: true, message: '工作内容' }]"
        />
        <!--<van-field
          v-model="addForm.location"
          v-if="isCreate"
          rows="1"
          autosize
          label="报修区域"
          type="textarea"
          placeholder="报修区域"
        />
        <van-field
          name="uploader"
         label="报修图片"
         v-if="isCreate"
        >
          <template #input>
            <van-uploader v-model="repairImageList"
                          :max-size="4096 * 1024"
                          multiple
                          :before-read="beforeRead"
                          :after-read="onReadRepairImage"
                          :before-delete="deleteRepairFile"
                          @oversize="onOversize"/>
          </template>
        </van-field>-->
        <van-cell title="选择工人" v-if="isCreate" style="text-align: left;" @click="showWorker()" is-link />
        <div v-if="addForm.selectedWorkers" style="overflow: hidden; margin-bottom: 20px;">
          <div v-for="(item, index) in addForm.selectedWorkers" v-bind:key="index" class="order_create_workers">
            <div class="order_create_workers_title" style="float: left; width: 70%; text-align: center;">{{ item.worker }}</div>
            <div class="order_create_workers_icon" @click="deleteWorker(index)" style="float: left">
              <van-icon name="cross" />
            </div>
          </div>
        </div>
        <van-popup v-model="showSelectWorker"
                   position="bottom"
                   :style="{ height: '60%' }"
                   closeable
                   close-icon="close"
        >
          <van-search
            style="margin-top: 40px"
            placeholder="搜索用户信息"
            v-model="searchData"
            @search="getUserList()"
            @input="getUserList()"
            @clear="getUserList()"
          ></van-search>
          <van-checkbox-group
            ref="checkboxGroup"
            @change="change"
            v-model="checkedValue"
          >
            <van-cell-group>
              <van-cell
                v-for="(item, index) in workers"
                clickable
                :key="item.worker_id"
                :title="item.worker"
                @click="toggle(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="item.worker_id" ref="checkboxes" shape="square" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <van-button native-type="button"  @click="submitSelectedUser" style="width: 150px; border-radius: 10px; position: fixed; bottom: 20px; right: 30%;" type="info">确定</van-button>
        </van-popup>
      </div>
      <div id="show-content">
        <div style="text-align: left;">明细</div>
        <div v-if="addForm.details.length >= 1" style="margin-bottom: 10px;">
          <div class="detail-list" v-for="(item, index) in addForm.details" @click="showDetail(item)">
            <div class="detail-left">
              <div>明细: {{ item.detail }}</div>
              <div>数量: {{ item.num }}</div>
              <div>单价: {{ item.price }}</div>
            </div>
            <div class="detail-right" v-if="item.detail !== '企业滴滴' && item.detail !== '企业货拉拉'">
              <van-icon v-if="showButton" name="delete" class="detail-delete-icon" @click.stop="deleteItem(index)" />
            </div>
          </div>
        </div>
        <div v-if="showButton" class="add-detail-btn" @click="addDetail">新增明细</div>
        <van-form validate-first @failed="onFailed" style="margin-bottom: 20px">
          <van-field
            v-model="addForm.total_price"
            rows="3"
            autosize
            readonly
            label="合计金额"
            type="text"
            placeholder="合计金额"
          />
          <van-field name="uploader" label="签收单" v-if="addForm.is_completed === 1">
            <template #input>
              <van-uploader v-model="imageList"
                            :max-size="100960 * 1024"
                            multiple
                            :before-read="beforeRead"
                            :after-read="onRead"
                            :before-delete="deleteFile"
                            @oversize="onOversize"/>
            </template>
          </van-field>
          <van-field name="uploader" label="发票或收据(可选)" v-if="addForm.pre_quote_status != 1">
            <template #input>
              <van-uploader v-model="receiptList"
                            :max-size="100960 * 1024"
                            multiple
                            :before-read="beforeRead"
                            :after-read="file => onReceiptRead(file)"
                            :before-delete="deleteReceiptFile"
                            @oversize="onOversize"/>
            </template>
          </van-field>
          <van-field name="radio" label="是否预支" v-if="addForm.pre_quote_status != 1 && !subordinateWorker">
            <template #input>
              <van-radio-group v-model="addForm.is_advance" direction="horizontal">
                <van-radio :name="0">否</van-radio>
                <van-radio :name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="是否在群里报备" v-if="addForm.pre_quote_status != 1 && !subordinateWorker">
            <template #input>
              <van-switch v-model="addForm.is_report" :active-value="1" :inactive-value="0" />
            </template>
          </van-field>
          <van-field
            v-model="addForm.remark"
            rows="2"
            autosize
            label="备注"
            type="textarea"
            placeholder="请输入备注"
            show-word-limit
          />
          <van-field
            v-if="addForm.status === 'reject_submit'"
            v-model="addForm.approve_remark"
            rows="2"
            autosize
            readonly
            label="审核意见"
            type="textarea"
            placeholder="审核意见"
            show-word-limit
          />
        </van-form>
      </div>
      <div style="width: 80%; display: flex; margin: 0 auto 20px;">
        <van-button v-if="showCreate" type="info" style="width: 100px; height: 35px; border-radius: 5px;float: left;margin: 20px 10px 20px 20px;" @click="onSubmit('create')">提交</van-button>
        <van-button v-if="showTmpSave" type="info" style="width: 100px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-bottom: 20px;" @click="onSubmit('tmp_save')">{{ tmpSaveTitle }}</van-button>
        <van-button v-if="showDelete" type="danger" style="width: 100px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-bottom: 20px; margin-left: 10px;" @click="deleteReim">删除</van-button>
        <van-button v-if="addForm.status === 'finance_payment'" type="primary" style="width: 100px; height: 35px; border-radius: 5px;float: left;margin-top: 20px; margin-bottom: 20px; margin-left: 100px;" @click="checkPayment">查看打款</van-button>
        <div clear="both"></div>
      </div>
    </van-form>
    <van-popup v-model="showAddContentPicker" position="bottom" :style="{ height: '100%', backgroundColor: '#f7f8fa' }">
      <reimbursement-detail
        v-if='newAdd'
        :visible.sync='newAdd'
        :show-id="contentId"
        :edit-status="showButton"
        :show-content="content"
        @actContent="hideDetail"
        @updateContent="updateDetail"
      ></reimbursement-detail>
    </van-popup>
    <van-popup v-model="showPaymentPicker" position="bottom" :style="{ height: '50%', backgroundColor: '#f7f8fa' }">
        <div v-for="(item, index) in paymentList" :key="index" style="margin: 10px;padding-bottom: 10px; border-bottom: 1px solid #ebedf0;">
          <div style="text-align: left;">付款金额: ￥{{ item.amount }}</div>
          <div style="text-align: left;">付款时间: {{ item.pay_at }}</div>
          <div style="height: 1px; width: 100%; background-color: #f8f8f8;"></div>
        </div>
    </van-popup>
  </div>
</template>
<script>
import {orderInfo,getImageOss,reimbursement, companies,searchWorkers, manCategoryLevel2} from '@/api/order'
import {reimbursementDetail,updateReimbursement} from '@/api/reimbursement'
import dayjs from 'dayjs'
import {Toast} from 'vant'
import OSS from 'ali-oss'
import ReimbursementDetail from './components/reimbursement_detail'
import * as math from 'mathjs'
import {
  addStore,
  getBrandList,
  getCityList,
  getMaCateLv0List,
  getMarketList,
  getOssToken,
  getShopList, parseAddress
} from "../../api/order"
import {
  createOrderAndReim,
  createOrUpdateRemiDetail,
  createRem, deleteReim,
  getCategories, getPaymentList,
  getReimInfo
} from "../../api/reimbursement";
import {getCompanyList} from "../../api/util";
import { Dialog } from 'vant'
import {getBaseInfo} from "../../api/user";

const TYPES = ['定期维护', '紧急维修', '活动']

export default {
  name: 'reimbursement',
  components: {
    ReimbursementDetail
  },
  data () {
    return {
      showCreate: false,
      showTmpSve: false,
      uploadLoading: false,
      tmpSaveTitle: '暂存',
      showTmpSave: false,
      showDelete: false,
      showPaymentPicker: false,
      paymentList: [],
      reim_no: '',
      showForm: {
        companyIndex: 0,
        cityIndex: 0,
        storeIndex: 0,
        brandIndex: 0,
        marketIndex: 0,
        typeIndex: 0,
        projectIndex: 0,
        city_name: '',
        brand_name: '',
        company_name: '',
        shop_name: '',
        market_name: '',
        project_name: '',
        opinion: '',
        status: ''
      },
      addForm: {
        is_completed: '',
        company_id: '',
        city_id: '',
        selectedWorkers: [],
        brand_id: '',
        shop_id: '',
        is_finished: 1,
        market_id: '',
        selected_column: '',
        sign_id_arr: [],
        man_ids: [],
        bill_id_arr: [],
        file_id_arr: [],
        sign_ids: '',
        file_ids: '',
        bill_ids: '',
        type: 0,
        typeCn: '',
        ma_remark: '',
        finished_at: '',
        details: [],
        is_report: false,
        remark: '',
        is_advance: '1',
        total_price: '',
        order_id: null,
        maintenance_id: null,
        id: null,
        approve_remark: ''
      },
      showBrandPicker: false,
      showStorePicker: false,
      showCalendar: false,
      title: '报销单',
      minDate: '',
      maxDate: new Date(),
      fileList: [],
      receiptList: [],
      checkedValue: [],
      showPicker: false,
      showTypePicker: false,
      columns: [],
      content: {},
      showContentPicker: false,
      id: undefined,
      contentId: undefined,
      newCreate: true,
      selectedDate: undefined,
      postContent: {
        score: '',
        desc: ''
      },
      showContent: false,
      showButton: true,
      newAdd: true,
      showAddContentPicker: false,
      showRepairEndTime: false,
      showCityPicker: false,
      showRepairStartTime: false,
      showSelectWorker: false,
      showMarketPicker: false,
      showCompanyPicker: false,
      workers: [],
      selectedWorkers: [],
      marketList: [],
      cityList: [],
      brandsList: [],
      imageList: [],
      repairImageList: [],
      marketsList: [],
      storeList: [],
      searchData: '',
      projects: [],
      companies: [],
      isCreate: false,
      loading: false,
      categories: [],
      input_content: '',
      reimStatus: '',
      subordinateWorker: false,
    }
  },
  async created () {
    await this.getBaseInfo()
    await this.initCategories()
    await this.initData()
    this.initAddForm()
    await this.initOptions()
    this.minDate = dayjs().subtract(100, 'day').toDate()
  },
  watch: {
    showForm: {
      handler(newValue, oldValue) {
        if (newValue.city_name !== '' && this.cityList.length > 0) {
          for (const i in this.cityList) {
            if (this.cityList[i].city === newValue.city_name) {
              this.showForm.cityIndex = i
              break
            }
          }
        }

        if (newValue.brand_name !== '' && this.brandsList.length > 0) {
          for (const i in this.brandsList) {
            if (this.brandsList[i].city === newValue.brand_name) {
              this.showForm.brandIndex = i
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getBaseInfo() {
      getBaseInfo().then((res) => {
        if (res.data.data && typeof res.data.data.subordinate_worker !== 'undefined') {
          this.subordinate_worker = res.data.data.subordinate_worker
        }
      })
    },
    explain() {
      if (this.input_content.length <= 0) {
        return false;
      }
      parseAddress({address: this.input_content}).then((res) => {
        console.log('res........', res)
        if (res.data.data) {
          if (res.data.data.brand_id) {
            this.addForm.brand_id = res.data.data.brand_id
            this.showForm.brand_name = res.data.data.brand_en
          } else {
            this.addForm.brand_id = 0
            this.showForm.brand_name = ''
          }
          if (res.data.data.city_id) {
            this.addForm.city_id = res.data.data.city_id
            this.showForm.city_name = res.data.data.city_cn
            this.initMarkets()
          } else {
            this.addForm.city_id = 0
            this.showForm.city_name = ''
          }
          if (res.data.data.market_id) {
            this.addForm.market_id = res.data.data.market_id
            this.showForm.market_name = res.data.data.market_cn
          } else {
            this.addForm.market_id = 0
            this.showForm.market_name = ''
          }
          if (res.data.data.shop_id) {
            this.addForm.store_id = res.data.data.shop_id
            this.showForm.store_cn = res.data.data.shop_cn
            this.searchStore()
          } else {
            this.addForm.store_id = 0
            this.showForm.store_cn = ''
          }
        }
      })
    },
    initCategories() {
      getMaCateLv0List().then((res) => {
        if (res.data.data) {
          this.categories = []
          this.columns = []
          for (const item in res.data.data) {
            this.columns.push(res.data.data[item])
            this.categories[res.data.data[item]] = item
          }
        }
      })
    },
    checkPayment() {
      getPaymentList({worker_reim_id: this.$route.query.reim_id}).then((res) => {
        if (res.data.data) {
          this.paymentList = res.data.data
          this.showPaymentPicker = true
        }
      })
    },
    deleteReim() {
      Dialog.confirm({
        title: '警告',
        message:
          '删除后将无法恢复，请确认删除',
      })
        .then(() => {
          deleteReim({reim_id: this.$route.query.reim_id}).then((res) => {
            if (res.data.code === 0) {
              Toast('删除成功')
              this.$router.push({ path: 'order_reimbursement_list' })
            }
          })
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteWorker (index) {
      this.addForm.selectedWorkers.splice(index, 1)
      this.addForm.man_ids.splice(index, 1)
    },
    showWorker() {
      this.showSelectWorker = true
      this.searchData = ''
    },
    submitSelectedUser() {
      if (this.checkedValue.length > 0) {
        for (const i in this.checkedValue) {
          if (this.addForm.man_ids.indexOf(this.checkedValue[i]) > -1) {
            continue
          }
          this.addForm.man_ids.push(this.checkedValue[i])
          for (const j in this.workers) {
            if (this.checkedValue[i] === this.workers[j].worker_id) {
              this.addForm.selectedWorkers.push(this.workers[j])
              break
            }
          }
        }
        this.showSelectWorker = false
        this.workers = []
        this.checkedValue = []
      }
    },
    getUserList() {
      if (this.searchData !== '' && typeof this.searchData !== 'undefined') {
        searchWorkers({search_str: this.searchData}).then(res => {
          this.workers = res.data.data
        })
      }
    },
    genNonDuplicateID(){
      let idStr = Date.now().toString(36)
      idStr += Math.random().toString(36).substr(2)
      return idStr
    },
    async initData() {
      if (this.$route.query.appo_task_id || this.$route.query.reim_id) {
        const queryData = {
          appo_task_id: this.$route.query.appo_task_id,
          reim_id: this.$route.query.reim_id,
          approve_sub_worker_reim: ''
        }
        if (this.$route.query.pre_quote_status) {
          queryData.pre_quote_status = this.$route.query.pre_quote_status
        }
        console.log('hahahahahahahahaah')
        await getReimInfo(queryData).then((res) => {
          if (res.data.data) {
            const data = res.data.data
            console.log('reslksskskskssssssss', data)
            if (data.id) {
              this.addForm.reim_id = data.id
            }
            if (data.reim_no) {
              this.reim_no = data.reim_no
            }
            if (typeof data.pre_quote_status !== 'undefined') {
              this.addForm.pre_quote_status = data.pre_quote_status
            } else if (this.$route.query.pre_quote_status) {
              this.addForm.pre_quote_status = this.$route.query.pre_quote_status
            }
            this.showForm.brand_name = data.brand_en
            this.addForm.brand_id = data.brand_id
            this.addForm.city_id = data.city_id
            this.showForm.city_name = data.city_cn
            this.addForm.store_id = data.store_id
            this.addForm.shop_id = data.store_id
            this.addForm.order_id = data.order_id
            this.showForm.company_en = data.company_en
            this.addForm.company_id = data.company_id
            this.addForm.appo_task_id = this.$route.query.appo_task_id
            this.addForm.annex_id = this.$route.query.annex_id
            this.showForm.store_cn = data.store_cn
            this.showForm.market_name = data.market_cn
            this.addForm.market_id = data.market_id
            this.addForm.finished_at = data.done_at
            this.addForm.type = data.type
            this.addForm.typeCn = TYPES[data.type]
            this.addForm.completed_at = data.done_at
            this.addForm.ma_cate_id = data.ma_cate_id
            this.addForm.ma_type = data.ma_type
            this.showForm.ma_type_cn = data.ma_type_cn
            this.showForm.ma_cate_cn = data.a_cate_cn
            this.addForm.ma_remark = data.ma_remark
            this.addForm.remark = data.remark
            this.addForm.total_price = data.total_price
            this.addForm.details = typeof data.reim_detail_list !== 'undefined' ? data.reim_detail_list : []
            this.addForm.is_report = typeof data.is_report !== 'undefined' ? data.is_report : 0
            this.addForm.is_advance = typeof data.is_advance !== 'undefined' ? data.is_advance : 0
            this.addForm.is_completed = typeof data.is_completed !== 'undefined' && data.is_completed !== null ? parseInt(data.is_completed) : 0
            this.addForm.completed_at = typeof data.completed_at !== 'undefined' && data.completed_at !== null && data.completed_at ? data.completed_at.replace(' 00:00:00', '') : ''
            this.addForm.status = data.status
            this.addForm.appo_task_id = data.appo_task_id
            this.imageList = []
            this.receiptList = []
            this.addForm.sign_id_arr = []
            this.addForm.bill_id_arr = []
            this.addForm.approve_remark = data.approve_remark
            for (const i in data.sign_file_list) {
              if (data.sign_file_list[i].file_id) {
                this.addForm.sign_id_arr.push(data.sign_file_list[i].file_id)
                this.imageList.push({url: data.sign_file_list[i].file_url_thumb})
              }
            }
            for (const i in data.bill_file_list) {
              if (data.bill_file_list[i].file_id) {
                this.addForm.bill_id_arr.push(data.bill_file_list[i].file_id)
                this.receiptList.push({url: data.bill_file_list[i].file_url_thumb})
              }
            }
            if (res.data.data.button && res.data.data.button.length > 0) {
              for (const i in res.data.data.button) {
                if (res.data.data.button[i].reim_status === 'create') {
                  this.showCreate = true
                }
                if (res.data.data.button[i].reim_status === 'tmp_save') {
                  this.showTmpSave = true
                  this.tmpSaveTitle = res.data.data.button[i].button_value
                }
                if (res.data.data.button[i].reim_status === 'delete') {
                  this.showTmpSave = true
                  this.tmpSaveTitle = res.data.data.button[i].button_value
                }
              }
            }
            if (typeof res.data.data.status === 'undefined' || res.data.data.status === '') {
              this.isCreate = true
              this.showCreate = true
              this.showTmpSave = true
            }
          }
        })
      } else {
        this.isCreate = true
        this.showCreate = true
        this.showTmpSave = true
        this.addForm.details = [{
          detail: '企业滴滴',
          num: 1,
          price: 0.0,
          unit: '项',
          total_price: 0.0,
          reim_detail_id: this.genNonDuplicateID()
        }]
        this.addForm.details.push({
          detail: '企业货拉拉',
          num: 1,
          price: 0.0,
          unit: '项',
          total_price: 0.0,
          reim_detail_id: this.genNonDuplicateID()
        })
        this.addForm.pre_quote_status = this.$route.query.pre_quote_status
        if (this.$route.query.pre_quote_status == 1) {
          this.addForm.is_completed = 0
          this.addForm.is_advance = 0
          this.addForm.is_report = 0
        }
      }
    },
    async initOptions() {
      await this.initCity()
      await this.initBrand()
      this.initProjects()
      this.initCompanies()
    },
    showDetail(data) {
      this.content = data
      this.newAdd = true
      this.showAddContentPicker = true
    },
    hideDetail() {
      this.newAdd = false
      this.showAddContentPicker = false
    },
    updateDetail(data) {
      this.showAddContentPicker = false
      this.newAdd = false
      let addResult = false
      for (const key in this.addForm.details) {
        if (this.addForm.details[key].reim_detail_id === data.reim_detail_id) {
          this.addForm.details[key] = data
          addResult = true
        }
      }
      if (!addResult) {
        this.addForm.details.push(data)
      }

      this.initTotalAmount()
    },
    initTotalAmount() {
      this.addForm.total_price = 0.00
      for (const i in this.addForm.details) {
        this.addForm.total_price = math.add(this.addForm.details[i].total_price, this.addForm.total_price)
      }

      this.addForm.total_price = math.round(this.addForm.total_price, 2)
    },
    initCompanies() {
      getCompanyList().then((res) => {
        if (res.data.data) {
          this.companies = res.data.data
        }
      })
    },
    initProjects () {
      this.projects = []
      getCategories({p_type: this.addForm.ma_type}).then((res) => {
        if (res.data.data) {
          console.log('categories......', res.data.data)
          for (const item in res.data.data) {
            this.projects.push({
              id: res.data.data[item].id,
              name: res.data.data[item].cn_name ? res.data.data[item].cn_name : res.data.data[item].en_name
            })
          }
        }
      })
    },
    initMarkets() {
      getMarketList({city_id: this.addForm.city_id}).then((res) => {
        if (res.data.data) {
          this.marketsList = res.data.data
        }
      })
    },
    onCancelBrand() {
      this.showBrandPicker = false
    },
    onConfirmBrand(evt) {
      this.addForm.brand_id = evt.id
      this.showForm.brand_name = evt.brand_en
      this.showBrandPicker = false
      this.searchStore()
    },
    onConfirmMarket(val) {
      this.showMarketPicker = false
      this.addForm.market_id = val.id
      this.showForm.market_name = val.market_cn
      this.searchStore()
    },
    onFailed() {

    },
    onChangeBrand() {

    },
    onConfirmCity(evt) {
      this.addForm.city_id = evt.id
      this.showForm.city_name = evt.city_cn
      this.showCityPicker = false
      this.initMarkets()
      this.searchStore()
    },
    onChangeCity(evt) {
      console.log('evt.....', evt)
    },
    onCancelCity() {
      this.showCityPicker = false
    },
    onOversize (file) {
    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile (file, index) {
      this.addForm.sign_id_arr.splice(index, 1)
      return true
    },
    async onReadRepairImage(file) {
      if (file.length > 1) {
        for (const i in file) {
          await this.uploadImg(file[i].file, 'repair')
        }
      } else {
        await this.uploadImg(file.file, 'repair')
      }
    },
    async onReceiptRead(file) {
      if (file.length > 1) {
        for (const i in file) {
          await this.uploadImg(file[i].file, 'bill')
        }
      } else {
        await this.uploadImg(file.file, 'bill')
      }
    },
    async onRead (file, name, index) {
      if (file.length > 1) {
        for (const i in file) {
          await this.uploadImg(file[i].file, 'sign')
        }
      } else {
        await this.uploadImg(file.file, 'sign')
      }
    },
    async uploadImg (file, index) {
      this.uploadLoading = true
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      await getOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              if (index === 'sign') {
                this.addForm.sign_id_arr.push(ossData.file_id)
              }
              if (index === 'bill') {
                this.addForm.bill_id_arr.push(ossData.file_id)
              }
              if (index === 'repair') {
                this.addForm.file_id_arr.push(ossData.file_id)
              }
              this.uploadLoading = false
            }
          })
        }
      })
    },
    parseType(file) {
      if (file.type === 'image/jpeg') {
        return 'jpeg'
      }
      if (file.type === 'image/png') {
        return 'png'
      }
      if (file.type === 'image/jpg') {
        return 'jpg'
      }
      return ''
    },
    deleteReceiptFile(file, index) {
      this.addForm.bill_id_arr.splice(index, 1)
      return true
    },
    deleteRepairFile(file, index) {
      this.addForm.file_id_arr.splice(index, 1)
    },
    change(evt) {
      console.log('evt...', evt)
    },
    onCancelMarket() {
      this.showMarketPicker = false
    },
    onCancelStore() {
      this.showStorePicker = false
    },
    async initCity() {
      await getCityList().then((res) => {
        if (res.data.data) {
          this.cityList = res.data.data
        }
      })
    },
    async initBrand() {
      await getBrandList().then((res) => {
        if (res.data.data) {
          this.brandsList = res.data.data
        }
      })
    },
    searchStore() {
      getShopList({city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id}).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.storeList = res.data.data
        } else {
          this.storeList = []
          this.storeList[0] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.showForm.city_name + this.showForm.market_name }
          this.storeList[1] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.showForm.city_name + this.showForm.market_name + '男装' }
          this.storeList[2] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.showForm.city_name + this.showForm.market_name + '女装' }
          this.storeList[3] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.showForm.city_name + this.showForm.market_name + '童装' }
          this.storeList[4] = { id: 0, city_id: this.addForm.city_id, brand_id: this.addForm.brand_id, market_id: this.addForm.market_id, name_cn: this.showForm.city_name + this.showForm.market_name + '鞋店' }
        }
      })
    },
    onConfirmStore(evt) {
      this.addForm.store_id = evt.id
      this.showForm.store_cn = evt.name_cn
      this.showStorePicker = false
    },
    async onSubmit(status) {
      if (this.loading) {
        return false
      }
      if (this.addForm.details.length < 1) {
        Toast('缺少明细');
        return false
      }
      if (this.uploadLoading) {
        Toast('图片上传中请耐心等待');
        return false
      }
      this.addForm.reim_detail_list = []
      for (const i in this.addForm.details) {
        let detail = this.addForm.details[i]
        if (typeof detail.reim_detail_id !== 'undefined') {
          delete detail.reim_detail_id
        }
        this.addForm.reim_detail_list.push(detail)
      }
      if (this.addForm.is_completed == 1 && (!this.addForm.completed_at || typeof this.addForm.completed_at === 'undefined')) {
        Toast('完工请填写完工日期')
        return false
      }
      if (this.$route.query.appo_task_id || this.$route.query.reim_id) {

        this.addForm.is_report = this.addForm.is_report ? 1 : 0

        this.addForm.bill_ids = this.addForm.bill_id_arr.join(',')
        this.addForm.sign_ids = this.addForm.sign_id_arr.join(',')
        //this.addForm.reim_detail_ids = reim_detail_ids.join(',')
        this.addForm.reim_status = status
        console.log("thislijflsdfj", this.addForm)
        createRem(this.addForm).then((res) => {
          if (res.data.code === 0) {
            Toast('提交成功')
            setTimeout(() => {
              if (this.$route.query.appo_task_id) {
                this.$router.push({ path: 'order_reimbursement_list', query: {ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id, pre_quote_status: this.addForm.pre_quote_status} })
              } else {
                this.$router.push({ path: 'order_reimbursement_list', query: {pre_quote_status: this.addForm.pre_quote_statu} })
              }
            }, 1000)
          }
        })
      } else {
        if (this.addForm.store_id === 0) {
          const store_info = {
            "store_name_cn": this.showForm.store_cn,
            "brand_id": this.addForm.brand_id,
            "city_id": this.addForm.city_id,
            "market_id": this.addForm.market_id
          }
          await addStore(store_info).then((res) => {
            if (res.data.data) {
              this.addForm.store_id = res.data.data
            }
          })
        }

        this.addForm.shop_id = this.addForm.store_id
        if (this.addForm.store_id === '' || typeof this.addForm.store_id === 'undefined') {
          Toast('缺少店铺')
          return false
        }
        this.addForm.bill_ids = typeof this.addForm.bill_id_arr !== 'undefined' ? this.addForm.bill_id_arr.join(',') : ''
        this.addForm.sign_ids = typeof this.addForm.sign_id_arr !== 'undefined' ? this.addForm.sign_id_arr.join(',') : ''
        console.log('eaParams.......', this.addForm)
        this.addForm.ma_item_list = [
          {
            ma_cate_id: this.addForm.ma_cate_id,
            prob_desc: this.addForm.ma_remark,
            location: this.addForm.location,
            file_ids: this.addForm.file_id_arr.join(','),
            appo_task_list: [{
              ma_end_at: '',
              submit_remark: '',
              ma_start_at: '',
              worker_ids: this.addForm.man_ids.join(',')
            }]
          }
        ]
        this.addForm.reim_status = status
        this.loading = true
        await createOrderAndReim(this.addForm).then((res) => {
          if (res.data.code > 0) {
            this.loading = false
            this.$message.error(res.data.msg)
          } else {
            this.loading = false
            this.$message.success('创建成功!')
            if (this.$route.query.appo_task_id) {
              this.$router.push({ path: 'order_reimbursement_list', query: {ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id} })
            } else {
              this.$router.push({ path: 'order_reimbursement_list' })
            }
          }
        })
      }
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    formatter (type, val) {
      if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      } else if (type === 'year') {
        return `${val}年`
      }
      return val
    },
    onConfirmDate (val) {
      console.log(val)
      const d = new Date(val)
      const dateTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.addForm.maintained_at = dateTime
      this.showCalendar = false
    },
    confirmDate (val) {
      const d = new Date(val)
      const dateTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.addForm.maintained_at = dateTime
      this.showPicker = false
    },
    onConfirm (val, index) {
      console.log('vale........', val)
      this.showForm.ma_type_cn = val
      this.addForm.ma_type = this.categories[val]
      this.initProjects()
      this.showTypePicker = false
      this.showForm.ma_cate_cn = ''
      this.addForm.ma_cate_id = ''
    },
    onCancel (val) {
      this.showTypePicker = false
    },
    cancel () {
      this.showPicker = false
    },
    onChange (val) {
      console.log(val)
    },
    async addDetail () {
      this.newAdd = true
      this.content = {}
      this.showAddContentPicker = true
    },
    async addContent () {
      this.showAddContentPicker = true
      this.contentId = undefined
      this.newAdd = true
    },
    actContent () {
      this.showContentPicker = false
    },
    initAddForm () {
      const id = this.$route.query.id
      if (id) {

      } else {
        const type = this.$route && this.$route.params && this.$route.params.type ? this.$route.params.type : 0
        this.addForm.type = type
        this.addForm.typeCn = this.columns[type]
      }
    },
    selectStartDate (val) {
      this.showRepairStartTime = false;
      this.addForm.completed_at = `${val.getFullYear()}-${val.getMonth() + 1}-${val.getDate()}`;
    },
    selectEndDate (val) {
      this.showRepairEndTime = false;
      this.addForm.end_at = this.formatDate(val)
    },
    formatDate(date) {
      return  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:00`;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    onConfirmColumn(evt) {
      console.log(evt)
      this.addForm.ma_cate_id = evt.id
      this.showForm.ma_cate_cn = evt.name
      this.showPicker = false
    },
    onChangeColumn() {

    },
    onConfirmCompany(val) {
      this.showCompanyPicker = false
      this.addForm.company_id = val.id
      this.showForm.company_en = val.company_en
      console.log(val)
    },
    onChangeCompany() {
    },
    deleteItem(index) {
      this.addForm.details.splice(index, 1)
      this.initTotalAmount()
    },
    cancelStartDate() {
      this.showRepairStartTime = false
    }
  }
}
</script>

<style scoped>
.create-form {
  margin-top: 20px;
  border-radius: 1px;
}
.create-title {
  border-radius: 80px;
  width: 94%;
  margin: 10px auto;
}
#show-content {
  width: 94%;
  margin: 10px auto;
}
.detail-list {
  background-color: #fdf6f7;
  border-radius: 5px;
  padding: 10px 0;
  width: 100%;
  margin: 2px auto;
  overflow: hidden;
  border: solid 2px #fde2e2;
}
.detail-left {
  float: left;
  padding-left: 16px;
  font-size: 14px;
  text-align: left;
}
.detail-right {
  float: right;
}
.detail-delete-icon {
  font-size: 20px;
  margin-right: 20px;
  margin-top: 20px;
}
.add-detail-btn {
  width: 100%;
  margin: 10px auto;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #878f9b;
  font-size: 16px;
  box-shadow: #666 0px 1px 3px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/reimbursement.vue